import { axios } from '@/utils/request'
import qs from 'qs'

let moduleName = 'account'

export function updatePassword(parameter) {
  console.log('data:', parameter)
  return axios({
    url: `/ws/${moduleName}/password`,
    method: 'put',
    data: parameter
  })
}


export default {
  updatePassword
}